/*
 * 数式の美術館 — スクロール連動フェードイン
 * custom.css の .reveal / .reveal--in と対で動く。
 * デザインの正: mockup/index.html ほか(0.8s / cubic-bezier(0.22,1,0.36,1))
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var selectors = [
    '.title-wrapper-with-link',
    '.title-wrapper',
    '.rich-text__wrapper',
    '.card-wrapper',
    '.multicolumn-list__item',
    '.image-with-text__content',
    '.collection-hero__text-wrapper',
    '.blog__post'
  ];

  var targets = document.querySelectorAll(selectors.join(','));

  targets.forEach(function (el) {
    el.classList.add('reveal');
    // グリッド内は列順に 90ms ずつ遅延(展示の照明が順に灯るように)
    var item = el.closest('.grid__item, .multicolumn-list__item');
    if (item && item.parentElement) {
      var idx = Array.prototype.indexOf.call(item.parentElement.children, item);
      el.style.transitionDelay = (idx % 4) * 90 + 'ms';
    }
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal--in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });
})();
